// (C) Copyright 2020 CNCC Services <https://www.cncc.fr/>
// This program is the sole property of CNCC Services and is not free software.

import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { RouteComponentProps } from "@reach/router";
import PageHeader from "../../../components/PageHeader";
import PageTitle from "../../../components/PageTitle";
import PageBody from "../../../components/PageBody";
import { AuthentifiedUser } from "../../../../api/backend-openapi";
import { useStore } from "effector-react";
import { authentifiedUserStore } from "../../../../state/auth/AuthStore";
import { NboAction } from "../../../types/AuthTypes";
import BroadcastListForm from "./BroadcastListForm";

interface BroadcastListEditProps extends RouteComponentProps {
  broadcastListId?: string;
}

const BroadcastListScreen: React.FunctionComponent<BroadcastListEditProps> = (
  props: BroadcastListEditProps
) => {
  const { t } = useTranslation();
  const authenticatedUser: AuthentifiedUser | null = useStore(
    authentifiedUserStore
  );
  const canEdit: boolean =
    (authenticatedUser &&
      authenticatedUser.rights &&
      authenticatedUser.rights.nboBroadcastList &&
      typeof authenticatedUser.rights.nboBroadcastList.find(
        broadcastList => broadcastList === NboAction.nboUpdate
      ) === "string") ||
    false;
  const canDelete: boolean =
    (authenticatedUser &&
      authenticatedUser.rights &&
      authenticatedUser.rights.nboBroadcastList &&
      typeof authenticatedUser.rights.nboBroadcastList.find(
        broadcastList => broadcastList === NboAction.nboDelete
      ) === "string") ||
    false;

  const [editMode, setEditMode] = useState<boolean>(false);
  const { broadcastListId } = props;
  return (
    <>
      <PageHeader>
        <PageTitle
          title={t(
            editMode
              ? "edit_broadcast_list.title"
              : "details_broadcast_list.title"
          )}
        />
      </PageHeader>
      <PageBody>
        <BroadcastListForm
          broadcastListId={broadcastListId ? broadcastListId : ""}
          editMode={editMode}
          setEditMode={setEditMode}
          canEdit={canEdit}
          canDelete={canDelete}
        />
      </PageBody>
    </>
  );
};

export default BroadcastListScreen;
